module.exports = __webpack_public_path__ + "img/养殖贷（对公）.d62b0279.png";